// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ljxzKU3ZG736L3Jlgn1F{display:flex;gap:8px;width:100%}._NLvrwgj5pa1ZBOF0bpH{height:40px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/members/ui/AssignMemberToInbox/ui/AssignMemberActions/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,OAAA,CACA,UAAA,CAGF,sBACE,WAAA","sourcesContent":[".container {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n.actionButton {\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ljxzKU3ZG736L3Jlgn1F`,
	"actionButton": `_NLvrwgj5pa1ZBOF0bpH`
};
export default ___CSS_LOADER_EXPORT___;
